<template>
	<section class="role_form">

		<div class="field">
			<label for="field01">Название</label>
			<input type="text" id="field01" v-model="model.name">
		</div>

		<div class="field">
			<label for="field02">Тип</label>
			<input type="text" id="field02" v-model="model.type" readonly/>
		</div>

	</section>
</template>
<script>
	export default {
		name: "RoleForm",
		props: ['model']
	}
</script>



// WEBPACK FOOTER //
// RoleForm.vue?0d4a80bf